import api from './api';

/**
 * Obtiene y devuelve directamente el objeto del usuario autenticado.
 * @returns {Promise<object>} El objeto de usuario.
 */
export const fetchUserApi = async () => {
  //console.info("🔍 Fetching user data from API...");
  // `api.get` devuelve el DTO del backend gracias a tu interceptor
  const response = await api.get('/api/user');
  // Devolvemos directamente la propiedad que nos interesa
  //console.info("✅ User data fetched successfully:", response.data.user);
  return response.data.user; 
};

// ... (el resto de funciones no cambian)
export const loginApi = (email, password) => {
  return api.post('/api/login', { email, password });
};

export const logoutApi = () => {
  return api.post('/api/logout');
};

/**
 * Registra un nuevo usuario.
 * @param {string} name - Nombre del usuario.
 * @param {string} email - Email del usuario.
 * @param {string} password - Contraseña.
 * @param {string} password_confirmation - Confirmación de contraseña.
 * @param {boolean} terms_accepted - Aceptación de términos.
 * @returns {Promise<object>} La respuesta del backend con token y user.
 */
export const registerApi = (name, email, password, password_confirmation, terms_accepted) => {
  return api.post('/api/register', {
    name,
    email,
    password,
    password_confirmation,
    terms_accepted
  });
};

/**
 * Llama al endpoint para cambiar el jugador activo del usuario.
 * @param {number} playerId - El ID del jugador a seleccionar.
 * @returns {Promise<object>} La respuesta del backend.
 */
export const selectPlayerApi = (playerId) => {
    return api.post(`/api/players/${playerId}/select`);
};

/**
 * Crea un nuevo player para el usuario autenticado.
 * @param {string} name - Nombre del nuevo player.
 * @returns {Promise<object>} La respuesta del backend con el player creado.
 */
export const createPlayerApi = (name) => {
    return api.post('/api/players', { name });
};

/**
 * Actualiza las properties (preferencias) del usuario.
 * @param {object} properties - Objeto con las properties a actualizar/agregar.
 * @returns {Promise<object>} La respuesta del backend con el user actualizado.
 */
export const updateUserPropertiesApi = (properties) => {
    return api.patch('/api/user/properties', { properties });
};

/**
 * Reenvía el email de verificación al usuario autenticado.
 * @returns {Promise<object>} La respuesta del backend.
 */
export const resendVerificationEmailApi = () => {
    return api.post('/api/email/resend-verification');
};